<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row mt-2">
      <h4 class="col-12">Classement général</h4>
    </div>

    <!-- lct.org scores -->
    <div class="row mt-4" v-if="!premium">
      <div class="col-12 text-center">
        <adsense
            ad-style="display:block"
            ad-client="ca-pub-1546035667994677"
            ad-slot="4664729357"
            ad-format="auto"></adsense>
      </div>
    </div>

    <div class="row">
      <ul class="col-12">
        <li v-for="month in displayedMonths" v-bind:key="month.getTime()"
        class="text-nowrap" v-on:click="changeMonth(month)">
          {{month.toLocaleDateString('fr-FR',{year: 'numeric', month: 'long'})}}
        </li>
        <li v-if="toggleMonths" v-on:click="toggleMonths = !toggleMonths" class="expand">
           Voir plus
        </li>
        <li v-else v-on:click="toggleMonths = !toggleMonths" class="expand">
           Voir moins
        </li>
      </ul>
    </div>
    <div class="row">
      <span class="col-12">Scores de {{currentRatingPeriod}}</span>
    </div>
    <div class="col align-self-center text-center " v-if="loading">
      <clip-loader />
    </div>
    <div class="mt-2 col-12" v-else>
      <div class="row">
        <div class="col-12 col-lg-3">
          Rechercher un joueur <input type="text" class="form-control"
          placeholder="Filtrer" v-model="filtre" v-on:keyup="filteredRates = filterResult()">
        </div>
      </div>
      <table class="table table-stripped table-sm mt-2">
        <thead>
          <tr>
            <th v-on:click="sort('rank')" class="sortable">#</th>
            <th>Joueur</th>
            <th v-on:click="sort('nbGames')" class="sortable">Nombre de parties</th>
            <th v-on:click="sort('rank')" class="sortable">Score LCT</th>
            <th v-on:click="sort('percentFromTop')" class="sortable">% du top</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="player in filteredRates" v-bind:key="player.userId"
          v-bind:class="scoreTdClass(player)">
            <td><img src="/static/cup.svg" width="20" v-if="player.rank === 1"/>{{player.rank}}</td>
            <td>{{player.username}}</td>
            <td>{{player.nbGames}}</td>
            <td>{{player.scoreLCT}}</td>
            <td>{{(player.percentFromTop/100).toFixed(2)}}%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import iam from '../iam';
import LoggedUser from './LoggedUser';
import ClipLoader from './ClipLoader';
import BottomNav from './BottomNav';
import adsense from './VueAdsense';

export default {
  name: 'Rating',
  data() {
    return {
      loading: true,
      toggleMonths: true,
      currentRatingPeriod: new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long' }),
      months: [],
      rates: [],
      username: iam.isAuthenticated() ? iam.getConnectedUser().username : undefined,
      filteredRates: [],
      filtre: '',
      actualSortField: 'rank',
      premium: iam.isPremium(),
    };
  },
  computed: {
    monthsClass() {
      return {
        'col-12': true,
        row: true,
        toggleMonths: this.toggleMonths,
      };
    },
    displayedMonths() {
      return this.toggleMonths ? this.months.slice(0, 8) : this.months;
    },
  },
  components: { LoggedUser, ClipLoader, BottomNav, adsense },
  async created() {
    const currentDate = new Date();
    const period = `${currentDate.getFullYear()}-${(`0${currentDate.getMonth() + 1}`).slice(-2)}`;

    const today = new Date();
    let month = 9;
    let year = 2012;
    const months = [new Date(Date.UTC(year, month))];
    while (month !== today.getMonth() || year !== today.getFullYear()) {
      year = month === 11 ? year + 1 : year;
      month = month === 11 ? 0 : month + 1;
      months.push(new Date(Date.UTC(year, month)));
    }
    this.months = months.reverse();
    this.rates = await this.getMonthlycores(period);
    this.filteredRates = this.filterResult();
    this.loading = false;
  },
  methods: {
    async getMonthlycores(period) {
      const response = await this.$http.get(`${process.env.LCT_API_URL}/monthly-scores?period=${period}`);
      return response.data
        .map((s, index, scores) => ({
          ...s,
          rank: scores.filter(p => Number(s.scoreLCT) < Number(p.scoreLCT)).length + 1,
        }))
        .sort((a, b) => a.rank - b.rank);
    },
    scoreTdClass(player) {
      return {
        me: player.username === this.username,
      };
    },
    async changeMonth(month) {
      this.loading = true;
      const period = `${month.getFullYear()}-${(`0${month.getMonth() + 1}`).slice(-2)}`;
      this.rates = await this.getMonthlycores(period);
      this.filteredRates = this.filterResult();
      this.currentRatingPeriod = month.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long' });
      this.loading = false;
    },
    filterResult() {
      return this.filtre
        ? this.rates.filter(r => r.username
        && r.username.toLowerCase().indexOf(this.filtre.toLowerCase()) >= 0)
        : this.rates;
    },
    sort(field) {
      if (field === this.actualSortField) {
        this.filteredRates.reverse();
        return;
      }
      this.actualSortField = field;
      if (field === 'rank') {
        this.filteredRates = this.filteredRates.sort((a, b) => a.rank - b.rank);
        return;
      }
      if (field === 'nbGames') {
        this.filteredRates = this.filteredRates.sort((a, b) => a.nbGames - b.nbGames);
        return;
      }
      if (field === 'percentFromTop') {
        this.filteredRates = this.filteredRates.sort((a, b) => a.percentFromTop - b.percentFromTop);
      }
    },
  },
};
</script>

<style scoped>
ul{
  list-style: none;
}
ul li{
  font-size: 0.8rem;
  float: left;
  margin-right: 20px;
}
ul li:hover {
  cursor: pointer;
}
.expand{
  color: #5dc596;
}
.me td{
  color: #6BBBAE;
  font-weight: bold;
}
.toggleMonths{
  height: 30px;
  overflow: hidden;
}
.sortable{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Rating.vue